import React from 'react';
import StarIcon from '@mui/icons-material/Star';

interface RatingIconProps {
  rating: number;
  className?: string;
}

const RatingIcon: React.FC<RatingIconProps> = ({ rating, className = '' }) => {
  return (
    <div className={`salon-rating ${className}`} aria-label={`Рейтинг: ${rating} зірок`}>
      <StarIcon style={{ color: '#f39c12', fontSize: '1rem' }} />
      <span>{rating}</span>
    </div>
  );
};

export default RatingIcon;
